import {
  REGISTRATION_ICON_TOOLTIP,
  REGISTRATION_LABEL,
  REGISTRATION_EXTRA_LABEL,
} from './constants';
import { enableRegistrationInput } from './eSocialRegistrationService';

export const registrationLabelMixin = {
  data() {
    return {
      registrationIconTooltipDesc: REGISTRATION_ICON_TOOLTIP,
      registrationLabel: REGISTRATION_LABEL,
      registrationExtraLabel: REGISTRATION_EXTRA_LABEL,
    };
  },
};

export const registrationActionMixin = {
  methods: {
    async onChangeRegistrationOptions(option) {
      await this.$nextTick();
      this.refreshForm();
      if (typeof this.setRegistrationOption === 'function') {
        this.setRegistrationOption(option);
      }
    },
  },
  computed: {
    registrationInputEnable() {
      return enableRegistrationInput(this.getRegistrationOption());
    },
  },
};
